import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      // Platform account that has not chosen a federation yet: every page needs one
      // (accounts with platform rights land on the Plateforme zone, the others on the choose page)
      if (this.authService.needsFederation()) {
        this.router.navigateByUrl(this.authService.homeWithoutFederation());
        return false;
      }
      const url = state.url;
      const isFedHome = url.startsWith('/federation');

      if (isFedHome && this.authService.isFederation()) {
        return true;
      }

      // If already logged in as federation, redirect to federation home
      if (this.authService.isFederation()) {
        this.router.navigate(['/federation/dashboard']);
        return false;
      }
    }

    // Not authenticated — redirect to login
    this.router.navigate(['/federation/auth/login']);
    return false;
  }
}
